import * as types from './actionTypes';
import {ajaxCallError} from './ajaxStatusActions';
import {Api} from '../api/Api';
import {beginAjaxCall} from './ajaxStatusActions';




export function getContableRegistroGastoListSuccess(contableregistrogasto) {
  return {type: types.LOAD_CONTABLEREGISTROGASTO_LIST_SUCCESS, contableregistrogasto};
}



export function getContableRegistroGastoList(pagina, regitrosPorPagina, filtro, showActivos, filtrosCombo, token) {
    
	return dispatch => {
		      dispatch(beginAjaxCall());
		      return Api().ContableRegistroGastoApi.getContableRegistroGastoList(pagina, regitrosPorPagina, filtro, showActivos, filtrosCombo, token).then(contableregistrogasto => {                  
                  dispatch(getContableRegistroGastoListSuccess(contableregistrogasto));
		      }).catch(error => {
		          dispatch(ajaxCallError());
		  throw(error);
		});
  	};
}



export function getContableRegistroGastoSuccess(catalogo) {
  return {type: types.LOAD_CONTABLEREGISTROGASTO_SUCCESS, catalogo};
}

export function getContableRegistroGasto(id, token) {
    return dispatch => {
        dispatch(beginAjaxCall());  
        return Api().ContableRegistroGastoApi.getContableRegistroGasto(id, token).then(contableregistrogasto => {   
        dispatch(getContableRegistroGastoSuccess(contableregistrogasto));
        return contableregistrogasto;
    }).catch(error => {
		dispatch(ajaxCallError()); 
      throw(error);
    });
  };
}



export function getContableRegistroGastoReporte(id, token) {
    return dispatch => {
        dispatch(beginAjaxCall());  
        return Api().ContableRegistroGastoApi.getContableRegistroGastoReporte(id, token).then(contableregistrogasto => {   
        dispatch(getContableRegistroGastoSuccess(contableregistrogasto));
        return contableregistrogasto;
    }).catch(error => {
		dispatch(ajaxCallError()); 
      throw(error);
    });
  };
}




export function saveSuccess(contableregistrogasto) {
  return {type: types.SAVE_CONTABLEREGISTROGASTO_SUCCESS, contableregistrogasto};
}


export function save(contableregistrogasto, token) {
    
  return dispatch => {
	dispatch(beginAjaxCall());  
    return Api().ContableRegistroGastoApi.save(contableregistrogasto, token).then(contableregistrogastoGuardado => {   
    dispatch(saveSuccess(contableregistrogastoGuardado));
    }).catch(error => {
		dispatch(ajaxCallError()); 
      throw(error);
    });
  };
}




export function getContableRegistroGastoComboSuccess(datos) {
  return {type: types.GET_CONTABLEREGISTROGASTOS_COMBO_SUCCESS, datos};
}

export function getContableRegistroGastoCombo(token) {
    
  return dispatch => {
     
	dispatch(beginAjaxCall());  
      
    return Api().ContableRegistroGastoApi.getContableRegistroGastoCombo(token).then(datos => {   
        
      dispatch(getContableRegistroGastoComboSuccess(datos));
    }).catch(error => {
		dispatch(ajaxCallError()); 
      throw(error);
    });
  };
}

export function borrarSuccess(contableregistrogasto) {
  return {type: types.BORRAR_CONTABLEREGISTROGASTO_SUCCESS, contableregistrogasto};
}


export function borrar(id, token ) {    
	return dispatch => {
		      dispatch(beginAjaxCall());
		      return Api().ContableRegistroGastoApi.borrar(id, token ).then(contableregistrogasto => {
               
                  dispatch(borrarSuccess(contableregistrogasto));
		      }).catch(error => {
		          dispatch(ajaxCallError());
		  throw(error);
		});
  	};
}




export function activarSuccess(contableregistrogasto) {
  return {type: types.ACTIVAR_CONTABLEREGISTROGASTO_SUCCESS, contableregistrogasto};
}


export function activar(id, token) {    
	return dispatch => {
		      dispatch(beginAjaxCall());
		      return Api().ContableRegistroGastoApi.activar(id, token).then(contableregistrogasto => {
               
                  dispatch(activarSuccess(contableregistrogasto));
		      }).catch(error => {
		          dispatch(ajaxCallError());
		  throw(error);
		});
  	};
}


export function setFiltro(filtroActivo, filtroActual, showActivos) {
	let filtro={
		filtroActivo,
		filtroActual,
        showActivos
	}
  return {type: types.SET_FILTRO_CONTABLEREGISTROGASTO, filtro};
}



